<app-tag
  *ngIf="tag"
  [show]="show"
  [label]="tag.name + ' Page'"
  color="#fff"
  size="small">
</app-tag>
